module.exports = __webpack_public_path__ + "img/01.75b347e3.jpg";